// src/components/Control/ZenohMonitor.tsx
import React from 'react';

interface ZenohMonitorProps {
  messages: string[]; // Массив отформатированных строк сообщений
}

const ZenohMonitor: React.FC<ZenohMonitorProps> = ({ messages }) => {
  return (
    <div id="zenohMessages">
      {messages && messages.length > 0 ? (
        messages.map((message, index) => (
          // Используем index как ключ, так как сообщения могут быть неуникальными.
          // Если у сообщений будет уникальный ID, лучше использовать его.
          <div key={index} className="zenoh-message">
            {message}
          </div>
        ))
      ) : (
        // Если сообщений нет, можно показать placeholder из оригинального HTML
        <p>Нет сообщений Zenoh.</p>
      )}
    </div>
  );
};

export default ZenohMonitor;